import { cn } from "@/utils/cn";
import { useRive } from "@rive-app/react-canvas";
import { memo } from "react";

interface RiveAnimationProps {
  src: string;
  className?: string;
}

const RiveAnimation = memo(function RiveAnimation({ src, className }: RiveAnimationProps) {
  const { RiveComponent } = useRive({
    src,
    autoplay: true,
  });

  return (
    <div className={cn("mx-auto flex h-28 w-28 items-center justify-center", className)}>
      <RiveComponent className="h-full w-full" />
    </div>
  );
});

export default RiveAnimation;
